import {
  Box,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { FC, useEffect } from "react";
import PhotoIcon from "@mui/icons-material/Photo";
import moment from "moment";
import { Note } from "../../../../../reducers/states/vcc-incident";
import useUserInfo from "../../../../../hooks/user-info";
import { NameOrEmailUtil } from "../../../../../utils/user-info-utils";
import { isImageFileUtil } from "../../../../../utils/import-utils";

interface IncidentNoteProps {
  props: {
    note: Note;
    handleOpenFile: (fileId: string, isImageType: boolean) => void;
  };
}

const IncidentNote: FC<IncidentNoteProps> = ({ props }) => {
  const [user, setUser] = useUserInfo();

  useEffect(() => {
    setUser(props.note.createdBy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.note.createdBy]);

  return (
    <Grid container key={props.note.id} alignItems={"center"}>
      <Grid item xs={9} ml={0} mr={0} pl={1} pr={1}>
        <Typography
          component={"span"}
          variant="body2"
          style={{ whiteSpace: "pre-wrap" }}
        >
          {props.note.content}
        </Typography>
        {props.note.imageIds &&
          props.note.imageIds.length > 0 &&
          props.note.imageIds.map((fileId) => (
            <Box key={fileId}>
              <Tooltip title={isImageFileUtil(fileId) ? "Click to view attachment" : "Click to download attachment"}>
                <IconButton
                  onClick={() => props.handleOpenFile(fileId, isImageFileUtil(fileId))}
                  key={fileId}
                  data-rum-id={`note-attachment__${fileId}`}
                  size="large"
                >
                  <PhotoIcon />
                </IconButton>
              </Tooltip>
            </Box>
          ))}
      </Grid>
      <Grid item xs={3} m={0} p={1}>
        <Typography component={"div"} variant={"body2"}>
          <Typography component={"span"} fontStyle="italic" fontSize="12px" display="block">
            Added by:
          </Typography>
          {NameOrEmailUtil(user) + (user.agency ? ` (${user.agency}) ` : " ")}<br />
          {moment(props.note.createdDate).format("LL, HH:mm:ss")}
        </Typography>
      </Grid>
      <Grid item xs={12} pl={1} pr={2}>
        <Divider />
      </Grid>
    </Grid>
  );
};

export default IncidentNote;
